export const GLOBAL_STATE = 'State'

export const STATE = 'state'
export const STATE_LIST = 'stateList'
export const STATE_ALL = 'stateAll'
export const STATE_CREATE = 'stateCreate'
